import { createContext } from 'react';

const HomeContext = createContext();
const IntroduceContext = createContext();
const ServiceContext = createContext();
const NewContext = createContext();
const RecruitmentContext = createContext();

export { HomeContext, IntroduceContext, ServiceContext, NewContext, RecruitmentContext };
